import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import { Direction } from '../../../shared/store-mocks/direction.store';
import { AdvancedFiltersFormDirectionStore } from './advanced-filters-form-direction.store';

@Component({
  selector: 'app-advanced-filters-form-direction',
  templateUrl: './advanced-filters-form-direction.component.html',
  styleUrls: ['./advanced-filters-form-direction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AdvancedFiltersFormDirectionStore]
})
export class AdvancedFiltersFormDirectionComponent implements OnInit, OnDestroy, ControlValueAccessor {

  onChange: any = () => {}
  onTouch: any = () => {}



  directionCurrentValue$ = this.store.directionValue$.pipe(map(
    (value: any) => {
      return value.length ? value.split(',').filter(s => s !== Direction.ALL) : []
    }
  ))
  directionEntities$ = this.store.entities$


  constructor(
    public ngControl: NgControl,
    private store: AdvancedFiltersFormDirectionStore

    ) {
      ngControl.valueAccessor = this;
    }

  ngOnInit(): void {}

  writeValue(value: string){}

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }

  directionValueChange(option: string[]) {
    this.saveValue(option.join(','))
  }

  saveValue(value){
    this.onChange(value)
    if(this.ngControl.untouched){
      this.onTouch()
    }
  }

  ngOnDestroy(){
    this.saveValue('')
  }
}
